var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdf == 'true')?_c('EmployeeWorklogReportPdf',{attrs:{"s-start-date":_vm.sStartDate,"s-end-date":_vm.sEndDate}}):_c('EmployeeWorklogReport',{attrs:{"s-start-date":_vm.sStartDate,"s-end-date":_vm.sEndDate}})}
var staticRenderFns = []

export { render, staticRenderFns }